export default __webpack_public_path__ + "static/media/parcel_bag.98218351.png";